import { render } from "./Archive_products.vue?vue&type=template&id=7d65571a"
import script from "./Archive_products.vue?vue&type=script&lang=js"
export * from "./Archive_products.vue?vue&type=script&lang=js"
script.render = render

export default script